import { Sparkles } from "lucide-react";

export const BrandLogo = ({ compact = false }) => (
  <a href="/" className="flex items-center gap-3 min-w-0 group" data-testid="brand-logo-link" aria-label="IdeaValidator360 home">
    <span className={`relative grid place-items-center shrink-0 rounded-xl bg-gradient-to-br from-[#2563EB] via-[#7C3AED] to-[#06B6D4] shadow-[0_0_24px_rgba(37,99,235,0.45)] transition-[transform,height,width] duration-300 group-hover:rotate-6 sm:h-10 sm:w-10 ${compact ? "h-8 w-8" : "h-10 w-10"}`}>
      <Sparkles className="h-5 w-5 text-white" aria-hidden="true" />
    </span>
    <span className="min-w-0">
      <span className="flex flex-wrap items-center gap-2">
        <span className="text-base sm:text-lg font-extrabold tracking-tight text-white">IdeaValidator360</span>
        <span className="rounded-full border border-cyan-400/40 bg-cyan-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-cyan-300" data-testid="engine-badge">
          20-Criteria Engine
        </span>
      </span>
      <span className={`truncate text-[11px] text-slate-400 sm:block ${compact ? "hidden" : "block"}`}>Validate • Visualise • Preview • Build • Fund</span>
    </span>
  </a>
);
